"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeViewWithDrag = exports.TreeViewWithoutDrag = exports.TreeView = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const Icons_1 = require("../Icons");
const Layout_1 = require("../Layout");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const style_1 = require("./style");
const react_i18next_1 = require("react-i18next");
const ALL_TYPE = "*";
const TreeView = (props) => {
    if (props.draggable)
        return react_1.default.createElement(exports.TreeViewWithDrag, { ...props });
    else
        return react_1.default.createElement(exports.TreeViewWithoutDrag, { ...props });
};
exports.TreeView = TreeView;
/** The version of the component without drag/drop */
exports.TreeViewWithoutDrag = react_1.default.memo((props) => {
    const { id, onClick, getChildren, isOpen } = props;
    const children = getChildren(id);
    const content = props.render({ id });
    if (content) {
        return (react_1.default.createElement(style_1.Wrapper, null,
            react_1.default.createElement(Layout_1.Flex, { width: "20px", flex: "0 0 auto" }, children.length > 0 && (react_1.default.createElement(style_1.ToggleButton, { "aria-label": "treeview toggle", onClick: (event) => {
                    event.preventDefault();
                    void onClick(id);
                } }, isOpen(id) ? react_1.default.createElement(Icons_1.ChevronUp, null) : react_1.default.createElement(Icons_1.ChevronDown, null)))),
            react_1.default.createElement(style_1.ContentCol, null,
                content,
                react_1.default.createElement(Layout_1.Flex, { col: true, noWrap: true }, isOpen(id)
                    ? children.map((node) => (react_1.default.createElement(exports.TreeViewWithoutDrag, { ...props, key: node === null || node === void 0 ? void 0 : node.id, id: node === null || node === void 0 ? void 0 : node.id })))
                    : null))));
    }
    else
        return null;
});
/** The version of the component with drag/drop */
exports.TreeViewWithDrag = react_1.default.memo((props) => {
    const { id, onClick, getChildren, isOpen } = props;
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    // Define drag behaviour
    const [, drag, preview] = (0, react_dnd_1.useDrag)({
        type: props.type || ALL_TYPE,
        item: {
            id,
            type: props.type || ALL_TYPE,
        },
        canDrag: () => (props.canDrag ? props.canDrag(id) : true),
    });
    // Define drop behaviour
    const [{ isOver, isDroppable }, drop] = (0, react_dnd_1.useDrop)({
        accept: props.accept || ALL_TYPE,
        canDrop: (item, monitor) => {
            if (monitor.isOver({ shallow: true })) {
                return props.canDrop ? props.canDrop(item.id, id) : item.id !== id;
            }
            return false;
        },
        drop: (item, monitor) => {
            if (!monitor.didDrop() && props.onDrop)
                props.onDrop({ drag: item.id, drop: id });
        },
        collect: (monitor) => ({
            isDroppable: monitor.canDrop(),
            isOver: monitor.isOver({ shallow: true }),
        }),
    });
    const attach = (node) => {
        drag(node);
        drop(node);
    };
    const children = getChildren(id);
    (0, react_1.useEffect)(() => {
        if (!props.draggable)
            return;
        preview((0, react_dnd_html5_backend_1.getEmptyImage)(), { captureDraggingState: true });
    }, [preview, props.draggable]);
    const content = props.render({
        id,
        isOver: !!(isOver && isDroppable),
    });
    if (content) {
        return (react_1.default.createElement(style_1.Wrapper, { ref: attach },
            react_1.default.createElement(Layout_1.Flex, { width: "20px", flex: "0 0 auto" }, children.length > 0 && (react_1.default.createElement(style_1.ToggleButton, { "aria-label": "treeview toggle", onClick: (event) => {
                    event.preventDefault();
                    onClick(id);
                } }, isOpen(id) ? (react_1.default.createElement(Icons_1.ChevronUp, { title: t("button-Collapse") })) : (react_1.default.createElement(Icons_1.ChevronDown, { title: t("button-Expand") }))))),
            react_1.default.createElement(style_1.ContentCol, null,
                content,
                react_1.default.createElement(Layout_1.Flex, { col: true, noWrap: true }, isOpen(id)
                    ? children.map((node) => (react_1.default.createElement(exports.TreeViewWithDrag, { ...props, key: node === null || node === void 0 ? void 0 : node.id, id: node === null || node === void 0 ? void 0 : node.id })))
                    : null))));
    }
    else
        return null;
});
//# sourceMappingURL=index.js.map